import { render, staticRenderFns } from "./OrdersUnallocated.vue?vue&type=template&id=23267423"
import script from "./OrdersUnallocated.vue?vue&type=script&lang=js"
export * from "./OrdersUnallocated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports